import { SubflowSteps } from '@/types/steps';
import findIndex from 'lodash/findIndex';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCurrentFlow } from './useCurrentFlow';

export const useAdvanceStep = () => {
  const { pathname, search } = useLocation();
  const { steps } = useCurrentFlow();
  const navigate = useNavigate();

  return () => {
    const currentStepIdx = findIndex(steps, ({ fullPath }) => fullPath.includes(pathname));
    const nextStep = steps[currentStepIdx + 1];
    if (nextStep) {
      navigate({ pathname: nextStep.fullPath, search });
    }
  };
};

export const useGoBackStep = () => {
  const { pathname, search } = useLocation();
  const { steps } = useCurrentFlow();
  const navigate = useNavigate();

  return () => {
    const currentStepIdx = findIndex(steps, ({ fullPath }) => fullPath.includes(pathname));
    let prevStep = steps[currentStepIdx - 1];
    // skip going back to calculating plan step when moving backwards
    if (prevStep.path === SubflowSteps.CalculatingPlan) {
      prevStep = steps[currentStepIdx - 2];
    }
    if (prevStep) {
      navigate({ pathname: prevStep.fullPath, search });
    }
  };
};
